import BasicText from "@/components/BasicText";
import Title from "@/components/Title";

import Image, { type StaticImageData } from "@/components/Image";
import polygonImage from "@/assets/images/why-node-polygon.png";

interface WhyNodeComponentProps {
  title: string;
  subtitle: string;
  src: string | StaticImageData;
  size: number;
}

const WhyNodeComponent: React.FC<WhyNodeComponentProps> = ({
  title,
  subtitle,
  src,
  size,
}) => {
  return (
    <div className="flex flex-col px-6 flex-1 justify-start items-start">
      <div className="flex md:flex-col gap-10 md:gap-4 items-start">
        <div className="w-[350px] h-20 relative">
          <Image src={polygonImage} alt="polygon" className="absolute" />
          <Image
            src={src}
            alt=''
            className="absolute left-6 top-[-10px]"
            style={{ width: `${size}px`, height: "auto" }}
          />
        </div>
        <Title className="text-[24px]">{title}</Title>
      </div>
      <BasicText className="mt-5" size="18px" color="faded">{subtitle}</BasicText>
    </div>
  );
};

export default WhyNodeComponent;
